// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #ffffff;
    /* color: #CCCCFF */
}

.EmailInput{
    display: flex;
  }
  
  .NoEmailInput{
    display: none;
  }
.socialemail{
    display: flex;
    flex-direction: column;
    width: 47%;
    margin-top: 20px;
}
.countryerrhide {
    border: 1px solid #dd3a3a00;
    display: block;
    
}

.countryerrshow {
    border: 1px solid #FF0000;
    
   
}
/* .detail-content {
    background-color: #F5F5F5;
    
    
} */
.shownot {
    position: fixed; 
    top: 0; 
    left: 0;
    background-color: #14b149; 
    color: #ffffff; 
    width: 100%; 
    padding-top: 5px; 
    padding-bottom: 5px
}

.hidenot{
    position: fixed; 
    top: 0; 
    left: 0;
    background-color: #14b149; 
    color: #ffffff; 
    width: 0px; 
    padding-top: 5px; 
    padding-bottom: 5px 
}



.shownot2 {
    position: fixed; 
    top: 0; 
    left: 0;
    background-color: #d33d29; 
    color: #ffffff; 
    width: 100%; 
    padding-top: 5px; 
    padding-bottom: 5px
}

.hidenot2{
    position: fixed; 
    top: 0; 
    left: 0;
    background-color: #d33d29; 
    color: #ffffff; 
    width: 0px; 
    padding-top: 5px; 
    padding-bottom: 5px 
}
.textinputs22 {
    border-radius: 10px;
    background-color: #EDECF8; 
    border: 1px solid #EDECF8; 
    height: 35px; 
    display: inline;
   
}

.loginicon2 {
    margin-left: 15px; 
    margin-right: 10px;
    height: 19px; 
    margin-top: 10px;
    display: inline
}


.textinputbody2 {
    display: flex;
    padding: 5px;
    border-radius: 10px;
    background-color: #EDECF8; 
    width: 300px;
    
   
}

.firsttopenroll {
    padding-top: 170px;
}



.firstarrow {
    position: absolute;
    left: 39.1%; 
    top: 148px;
}

.firstarrow2nd {
    width: 156px; 
    height: 3px; 
    background-color: #156614
}

/* second arrow */
.secondarrow {
    position: absolute; 
    left: 53.5%;
    top: 148px
}

.secondarrow2nd {
    width: 155px; 
    height: 3px; 
    background-color: #96c596
}


.firstarrow2 {
    position: absolute; 
    left: 39.3%; 
    top: 148px;
}

.secondarrow2 {
    position: absolute; 
    left: 53.5%; 
    top: 148px
}

.firstarrow21st{
    width: 153px; 
    height: 3px; 
    background-color: #156614;
}

.secondarrow21st{
    width: 155px; 
    height: 3px; 
    background-color: #96c596
}

.firstarrow3 {
    position: absolute; 
    left: 39.3%; 
    top: 148px
}

.secondarrow3 {
    position: absolute; 
    left: 53.5%; 
    top: 148px
}

.thirdarrow3 {
    width: 154px; 
    height: 3px; 
    background-color: #156614
}

.thirdarrow32 {
    width: 154px; 
    height: 3px; 
    background-color: #96c596
}

.Enroll-top2 {
    margin-top: 150px;

    
}

.Enroll-page {
    background-color: #ffffff; 
    z-index: 100;
    width: "100%";
}

.textinputs2 {
    border-radius: 10px;
    background-color: #EDECF8; 
    border: 1px solid #dd3a3a; 
    height: 40px; 
    width: 240px;
   
}



.textinputs {
    border-radius: 10px;
    display: block;
    background-color: #EDECF8; 
    border: 1px solid #EDECF8; 
    height: 40px; 
    width: 240px;
    
}

.textinputs2p {
    border-radius: 10px;
    border: 1px solid #dd3a3a; 
    height: 38px; 
    width: 303px;
   
}



.textinputsp {
    border-radius: 10px;
    border: 1px solid #dd3a3a00;
    display: block;
    height: 38px; 
    width: 290px;
   
}

/* .errortext {
    color: #000000
} */

.errortext {
    color: #dd3a3a;
}

.errortext2 {
    color: #dd3a3a;
}

.errortext3 {
    color: #000000;
}

input:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
}

.formbtn {
    width: 100px; 
    height: 35px; 
     
    margin-top: 15px; 
    background-color: #156614; 
    font-size: 13px
}

.firstcontent {
    margin-top: 70px; 
    margin-bottom: 70px; 
    margin-left: 70px; 
    margin-right: 5px
}

.secondcontent {
    margin-top: 70px; 
    margin-bottom: 70px;
    margin-left: 70px; 
    margin-right: 5px;
}


.myfirstcon {
    margin-top: 120px; 
    margin-bottom: 70px; 
    margin-left: 70px; 
    margin-right: 5px;
}

.sideshifft {
    margin: "70px"
}

.successtabs {
    margin-top: 150px; 
    margin-bottom: 100px; 
    margin-left: 170px; 
    margin-right: 5px;
}

@media (min-width: 297px) and (max-width: 385px){
    
    .firsttopenroll {
        padding-top: 230px;
    }


    .firstarrow {
        position: absolute;
        left: 37.9%; 
        top: 215px;
    }

    .firstarrow1st{
        font-size: 12px;
    }

    .firstarrow2nd {
        width: 52px; 
        height: 3px; 
        background-color: #156614
    }


    
    .secondarrow {
        position: absolute; 
        left: 63.2%;
        top: 215px;
    }

    .secondarrow2nd{
        width: 52px;
    }

    .secondarrow21st{
        width: 52px; 
        
    }

    /* second arrow */

    .firstarrow2 {
        position: absolute; 
        left: 37.7%; 
        top: 215px;
    }

    .secondarrow2 {
        position: absolute; 
        left: 63.2%;
        top: 215px;
    }

    .firstarrow21st{
        width: 53px; 
        height: 3px; 
        background-color: #156614;
    }

    .firstarrow3 {
        position: absolute; 
        left: 37.7%; 
        top: 215px
    }

    .thirdarrow3 {
        width: 53px; 
        
    }

    .secondarrow3 {
        position: absolute; 
        left: 63.2%; 
        top: 215px
    }

    .thirdarrow32 {
        width: 53px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}


@media (min-width: 387px) and (max-width: 585px){
    
    .firsttopenroll {
        padding-top: 230px;
    }


    .firstarrow {
        position: absolute;
        left: 37.9%; 
        top: 215px;
    }

    .firstarrow1st{
        font-size: 12px;
    }

    .firstarrow2nd {
        width: 52px; 
        height: 3px; 
        background-color: #156614
    }


    
    .secondarrow {
        position: absolute; 
        left: 63.2%;
        top: 215px;
    }

    .secondarrow2nd{
        width: 52px;
    }

    .secondarrow21st{
        width: 52px; 
        
    }

    /* second arrow */

    .firstarrow2 {
        position: absolute; 
        left: 37.7%; 
        top: 215px;
    }

    .secondarrow2 {
        position: absolute; 
        left: 63.2%;
        top: 215px;
    }

    .firstarrow21st{
        width: 53px; 
        height: 3px; 
        background-color: #156614;
    }

    .firstarrow3 {
        position: absolute; 
        left: 37.7%; 
        top: 215px
    }

    .thirdarrow3 {
        width: 53px; 
        
    }

    .secondarrow3 {
        position: absolute; 
        left: 63.2%; 
        top: 215px
    }

    .thirdarrow32 {
        width: 53px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}



@media  (min-width: 597px) and (max-width: 990px) {
    
    .firsttopenroll {
        padding-top: 180px;
    }


    .firstarrow {
        position: absolute;
        left: 42.8%; 
        top: 165px;
    }

    .firstarrow1st{
        font-size: 12px;
    }

    .firstarrow2nd {
        width: 52px; 
        height: 3px; 
        background-color: #156614
    }


    
    .secondarrow {
        position: absolute; 
        left: 58.2%;
        top: 165px;
    }

    .secondarrow2nd{
        width: 52px;
    }

    .secondarrow21st{
        width: 52px; 
        
    }

    /* second arrow */

    .firstarrow2 {
        position: absolute; 
        left: 42.8%; 
        top: 165px;
    }

    .secondarrow2 {
        position: absolute; 
        left: 58.2%; 
        top: 165px;
    }

    .firstarrow21st{
        width: 53px; 
        height: 3px; 
        background-color: #156614;
    }

    .firstarrow3 {
        position: absolute; 
        left: 42.8%; 
        top: 165px;
    }

    .thirdarrow3 {
        width: 53px; 
        
    }

    .secondarrow3 {
        position: absolute; 
        left: 58.2%; 
        top: 165px;
    }

    .thirdarrow32 {
        width: 53px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}


@media  (min-width: 998px) and (max-width: 1090px) {
    
    .firsttopenroll {
        padding-top: 220px;
    }


    .firstarrow {
        position: absolute;
        left: 42.8%; 
        top: 205px;
    }

    .firstarrow1st{
        font-size: 12px;
    }

    .firstarrow2nd {
        width: 52px; 
        height: 3px; 
        background-color: #156614
    }


    
    .secondarrow {
        position: absolute; 
        left: 58.2%;
        top: 205px;
    }

    .secondarrow2nd{
        width: 52px;
    }

    .secondarrow21st{
        width: 52px; 
        
    }

    /* second arrow */

    .firstarrow2 {
        position: absolute; 
        left: 42.8%; 
        top: 205px;
    }

    .secondarrow2 {
        position: absolute; 
        left: 58.2%; 
        top: 205px;
    }

    .firstarrow21st{
        width: 53px; 
        height: 3px; 
        background-color: #156614;
    }

    .firstarrow3 {
        position: absolute; 
        left: 42.8%; 
        top: 205px;
    }

    .thirdarrow3 {
        width: 53px; 
        
    }

    .secondarrow3 {
        position: absolute; 
        left: 58.2%; 
        top: 205px;
    }

    .thirdarrow32 {
        width: 53px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}



@media  (min-width: 1100px) and (max-width: 1290px) {
    
    .firsttopenroll {
        padding-top: 220px;
    }


    .firstarrow {
        position: absolute;
        left: 42.8%; 
        top: 205px;
    }

    .firstarrow1st{
        font-size: 12px;
    }

    .firstarrow2nd {
        width: 52px; 
        height: 3px; 
        background-color: #156614
    }


    
    .secondarrow {
        position: absolute; 
        left: 58.2%;
        top: 205px;
    }

    .secondarrow2nd{
        width: 52px;
    }

    .secondarrow21st{
        width: 52px; 
        
    }

    /* second arrow */

    .firstarrow2 {
        position: absolute; 
        left: 42.8%; 
        top: 205px;
    }

    .secondarrow2 {
        position: absolute; 
        left: 58.2%; 
        top: 205px;
    }

    .firstarrow21st{
        width: 53px; 
        height: 3px; 
        background-color: #156614;
    }

    .firstarrow3 {
        position: absolute; 
        left: 42.8%; 
        top: 205px;
    }

    .thirdarrow3 {
        width: 53px; 
        
    }

    .secondarrow3 {
        position: absolute; 
        left: 58.2%; 
        top: 205px;
    }

    .thirdarrow32 {
        width: 53px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}


/* 90% screen */
@media (min-width: 1400px) and (max-width: 1590px){
    
    .firsttopenroll {
        padding-top: 170px;
    }
    
    
    
    .firstarrow {
        position: absolute;
        left: 38.4%; 
        top: 148px;
    }
    
    .firstarrow2nd {
        width: 182px; 
        height: 3px; 
        background-color: #156614
    }
    
    /* second arrow */
    .secondarrow {
        position: absolute; 
        left: 53.2%;
        top: 148px
    }
    
    .secondarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }
    
    
    .firstarrow2 {
        position: absolute; 
        left: 38.3%; 
        top: 148px;
    }
    
    .secondarrow2 {
        position: absolute; 
        left: 53.2%; 
        top: 148px
    }
    
    .firstarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #156614;
    }
    
    .secondarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #96c596
    }
    
    .firstarrow3 {
        position: absolute; 
        left: 38.3%; 
        top: 148px
    }
    
    .secondarrow3 {
        position: absolute; 
        left: 53.2%; 
        top: 148px
    }
    
    .thirdarrow3 {
        width: 184px; 
        height: 3px; 
        background-color: #156614
    }
    
    .thirdarrow32 {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}


/* 80% screen */
@media (min-width: 1600px) and (max-width: 1740px){
    
    .firsttopenroll {
        padding-top: 170px;
    }
    
    
    
    .firstarrow {
        position: absolute;
        left: 39.6%; 
        top: 148px;
    }
    
    .firstarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #156614
    }
    
    /* second arrow */
    .secondarrow {
        position: absolute; 
        left: 52.8%;
        top: 148px
    }
    
    .secondarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }
    
    
    .firstarrow2 {
        position: absolute; 
        left: 39.6%; 
        top: 148px;
    }
    
    .secondarrow2 {
        position: absolute; 
        left: 52.8%; 
        top: 148px
    }
    
    .firstarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #156614;
    }
    
    .secondarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #96c596
    }
    
    .firstarrow3 {
        position: absolute; 
        left: 39.6%; 
        top: 148px
    }
    
    .secondarrow3 {
        position: absolute; 
        left: 52.8%; 
        top: 148px
    }
    
    .thirdarrow3 {
        width: 184px; 
        height: 3px; 
        background-color: #156614
    }
    
    .thirdarrow32 {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}




/* 75% screen */
@media (min-width: 1790px) and (max-width: 1890px){
    
    .firsttopenroll {
        padding-top: 170px;
    }
    
    
    
    .firstarrow {
        position: absolute;
        left: 40.3%; 
        top: 148px;
    }
    
    .firstarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #156614
    }
    
    /* second arrow */
    .secondarrow {
        position: absolute; 
        left: 52.7%;
        top: 148px
    }
    
    .secondarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }
    
    
    .firstarrow2 {
        position: absolute; 
        left: 40.3%; 
        top: 148px;
    }
    
    .secondarrow2 {
        position: absolute; 
        left: 52.7%; 
        top: 148px
    }
    
    .firstarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #156614;
    }
    
    .secondarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #96c596
    }
    
    .firstarrow3 {
        position: absolute; 
        left: 40.3%; 
        top: 148px
    }
    
    .secondarrow3 {
        position: absolute; 
        left: 52.6%; 
        top: 148px
    }
    
    .thirdarrow3 {
        width: 184px; 
        height: 3px; 
        background-color: #156614
    }
    
    .thirdarrow32 {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}




/* 67% screen */
@media (min-width: 1900px) and (max-width: 3000px){
    
    .firsttopenroll {
        padding-top: 170px;
    }
    
    
    
    .firstarrow {
        position: absolute;
        left: 41.4%; 
        top: 148px;
    }
    
    .firstarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #156614
    }
    
    /* second arrow */
    .secondarrow {
        position: absolute; 
        left: 52.3%;
        top: 148px
    }
    
    .secondarrow2nd {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }
    
    
    .firstarrow2 {
        position: absolute; 
        left: 41.3%; 
        top: 148px;
    }
    
    .secondarrow2 {
        position: absolute; 
        left: 52.3%; 
        top: 148px
    }
    
    .firstarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #156614;
    }
    
    .secondarrow21st{
        width: 184px; 
        height: 3px; 
        background-color: #96c596
    }
    
    .firstarrow3 {
        position: absolute; 
        left: 41.3%; 
        top: 148px
    }
    
    .secondarrow3 {
        position: absolute; 
        left: 52.3%; 
        top: 148px
    }
    
    .thirdarrow3 {
        width: 184px; 
        height: 3px; 
        background-color: #156614
    }
    
    .thirdarrow32 {
        width: 183px; 
        height: 3px; 
        background-color: #96c596
    }

    .Enroll-top2 {
        margin-top: 150px;

        
    }

    /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */


    .Enroll-page {
        background-color: #ffffff; 
        z-index: 100;
        width: "100%";
    }

    .myfirstcon {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px;
    }

    .sideshifft {
        margin: "50px"
    }



    .textinputs {
        border-radius: 10px;
        background-color: #EDECF8; 
        border: 1px solid #EDECF8; 
        height: 40px; 
        width: 240px;
    
    }

    input:focus {
        outline:none !important;
        outline-width: 0 !important;
        box-shadow: none;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
    }

    .formbtn {
        width: 100px; 
        height: 35px; 
        
        margin-top: 15px; 
        background-color: #156614; 
        font-size: 13px
    }

    .firstcontent {
        margin-top: 70px; 
        margin-bottom: 70px; 
        margin-left: 20px; 
        margin-right: 5px
    }

    .secondcontent {
        margin-top: 70px; 
        margin-bottom: 70px;
        margin-left: 20px; 
        margin-right: 5px;
    }


    .successtabs {
        margin-top: 150px; 
        margin-bottom: 100px; 
        margin-left: 50px; 
        margin-right: 5px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/SignUp.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;IACI,yBAAyB;;;AAG7B;AACA;;;;GAIG;AACH;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB;AACJ;;;;AAIA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB;AACJ;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;;;AAGhB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;;;AAGrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;;AAEhB;;;;AAIA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;;AAEhB;;;;AAIA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,YAAY;;AAEhB;;AAEA;;GAEG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI;QACI,kBAAkB;IACtB;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA,iBAAiB;;IAEjB;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;AAGA;;IAEI;QACI,kBAAkB;IACtB;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA,iBAAiB;;IAEjB;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;;AAIA;;IAEI;QACI,kBAAkB;IACtB;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA,iBAAiB;;IAEjB;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;AAGA;;IAEI;QACI,kBAAkB;IACtB;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA,iBAAiB;;IAEjB;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;;AAIA;;IAEI;QACI,kBAAkB;IACtB;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA,iBAAiB;;IAEjB;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;AAGA,eAAe;AACf;;IAEI;QACI,kBAAkB;IACtB;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA,iBAAiB;IACjB;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;AAGA,eAAe;AACf;;IAEI;QACI,kBAAkB;IACtB;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA,iBAAiB;IACjB;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;;;AAKA,eAAe;AACf;;IAEI;QACI,kBAAkB;IACtB;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA,iBAAiB;IACjB;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;;;;AAKA,eAAe;AACf;;IAEI;QACI,kBAAkB;IACtB;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA,iBAAiB;IACjB;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;;;IAGrB;;IAEA;;;OAGG;;;IAGH;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;;;IAIA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;;IAEhB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;QAChB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,yBAAyB;QACzB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;;;IAGA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ","sourcesContent":["body {\n    background-color: #ffffff;\n    /* color: #CCCCFF */\n}\n\n.EmailInput{\n    display: flex;\n  }\n  \n  .NoEmailInput{\n    display: none;\n  }\n.socialemail{\n    display: flex;\n    flex-direction: column;\n    width: 47%;\n    margin-top: 20px;\n}\n.countryerrhide {\n    border: 1px solid #dd3a3a00;\n    display: block;\n    \n}\n\n.countryerrshow {\n    border: 1px solid #FF0000;\n    \n   \n}\n/* .detail-content {\n    background-color: #F5F5F5;\n    \n    \n} */\n.shownot {\n    position: fixed; \n    top: 0; \n    left: 0;\n    background-color: #14b149; \n    color: #ffffff; \n    width: 100%; \n    padding-top: 5px; \n    padding-bottom: 5px\n}\n\n.hidenot{\n    position: fixed; \n    top: 0; \n    left: 0;\n    background-color: #14b149; \n    color: #ffffff; \n    width: 0px; \n    padding-top: 5px; \n    padding-bottom: 5px \n}\n\n\n\n.shownot2 {\n    position: fixed; \n    top: 0; \n    left: 0;\n    background-color: #d33d29; \n    color: #ffffff; \n    width: 100%; \n    padding-top: 5px; \n    padding-bottom: 5px\n}\n\n.hidenot2{\n    position: fixed; \n    top: 0; \n    left: 0;\n    background-color: #d33d29; \n    color: #ffffff; \n    width: 0px; \n    padding-top: 5px; \n    padding-bottom: 5px \n}\n.textinputs22 {\n    border-radius: 10px;\n    background-color: #EDECF8; \n    border: 1px solid #EDECF8; \n    height: 35px; \n    display: inline;\n   \n}\n\n.loginicon2 {\n    margin-left: 15px; \n    margin-right: 10px;\n    height: 19px; \n    margin-top: 10px;\n    display: inline\n}\n\n\n.textinputbody2 {\n    display: flex;\n    padding: 5px;\n    border-radius: 10px;\n    background-color: #EDECF8; \n    width: 300px;\n    \n   \n}\n\n.firsttopenroll {\n    padding-top: 170px;\n}\n\n\n\n.firstarrow {\n    position: absolute;\n    left: 39.1%; \n    top: 148px;\n}\n\n.firstarrow2nd {\n    width: 156px; \n    height: 3px; \n    background-color: #156614\n}\n\n/* second arrow */\n.secondarrow {\n    position: absolute; \n    left: 53.5%;\n    top: 148px\n}\n\n.secondarrow2nd {\n    width: 155px; \n    height: 3px; \n    background-color: #96c596\n}\n\n\n.firstarrow2 {\n    position: absolute; \n    left: 39.3%; \n    top: 148px;\n}\n\n.secondarrow2 {\n    position: absolute; \n    left: 53.5%; \n    top: 148px\n}\n\n.firstarrow21st{\n    width: 153px; \n    height: 3px; \n    background-color: #156614;\n}\n\n.secondarrow21st{\n    width: 155px; \n    height: 3px; \n    background-color: #96c596\n}\n\n.firstarrow3 {\n    position: absolute; \n    left: 39.3%; \n    top: 148px\n}\n\n.secondarrow3 {\n    position: absolute; \n    left: 53.5%; \n    top: 148px\n}\n\n.thirdarrow3 {\n    width: 154px; \n    height: 3px; \n    background-color: #156614\n}\n\n.thirdarrow32 {\n    width: 154px; \n    height: 3px; \n    background-color: #96c596\n}\n\n.Enroll-top2 {\n    margin-top: 150px;\n\n    \n}\n\n.Enroll-page {\n    background-color: #ffffff; \n    z-index: 100;\n    width: \"100%\";\n}\n\n.textinputs2 {\n    border-radius: 10px;\n    background-color: #EDECF8; \n    border: 1px solid #dd3a3a; \n    height: 40px; \n    width: 240px;\n   \n}\n\n\n\n.textinputs {\n    border-radius: 10px;\n    display: block;\n    background-color: #EDECF8; \n    border: 1px solid #EDECF8; \n    height: 40px; \n    width: 240px;\n    \n}\n\n.textinputs2p {\n    border-radius: 10px;\n    border: 1px solid #dd3a3a; \n    height: 38px; \n    width: 303px;\n   \n}\n\n\n\n.textinputsp {\n    border-radius: 10px;\n    border: 1px solid #dd3a3a00;\n    display: block;\n    height: 38px; \n    width: 290px;\n   \n}\n\n/* .errortext {\n    color: #000000\n} */\n\n.errortext {\n    color: #dd3a3a;\n}\n\n.errortext2 {\n    color: #dd3a3a;\n}\n\n.errortext3 {\n    color: #000000;\n}\n\ninput:focus {\n    outline:none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n}\n\n.formbtn {\n    width: 100px; \n    height: 35px; \n     \n    margin-top: 15px; \n    background-color: #156614; \n    font-size: 13px\n}\n\n.firstcontent {\n    margin-top: 70px; \n    margin-bottom: 70px; \n    margin-left: 70px; \n    margin-right: 5px\n}\n\n.secondcontent {\n    margin-top: 70px; \n    margin-bottom: 70px;\n    margin-left: 70px; \n    margin-right: 5px;\n}\n\n\n.myfirstcon {\n    margin-top: 120px; \n    margin-bottom: 70px; \n    margin-left: 70px; \n    margin-right: 5px;\n}\n\n.sideshifft {\n    margin: \"70px\"\n}\n\n.successtabs {\n    margin-top: 150px; \n    margin-bottom: 100px; \n    margin-left: 170px; \n    margin-right: 5px;\n}\n\n@media (min-width: 297px) and (max-width: 385px){\n    \n    .firsttopenroll {\n        padding-top: 230px;\n    }\n\n\n    .firstarrow {\n        position: absolute;\n        left: 37.9%; \n        top: 215px;\n    }\n\n    .firstarrow1st{\n        font-size: 12px;\n    }\n\n    .firstarrow2nd {\n        width: 52px; \n        height: 3px; \n        background-color: #156614\n    }\n\n\n    \n    .secondarrow {\n        position: absolute; \n        left: 63.2%;\n        top: 215px;\n    }\n\n    .secondarrow2nd{\n        width: 52px;\n    }\n\n    .secondarrow21st{\n        width: 52px; \n        \n    }\n\n    /* second arrow */\n\n    .firstarrow2 {\n        position: absolute; \n        left: 37.7%; \n        top: 215px;\n    }\n\n    .secondarrow2 {\n        position: absolute; \n        left: 63.2%;\n        top: 215px;\n    }\n\n    .firstarrow21st{\n        width: 53px; \n        height: 3px; \n        background-color: #156614;\n    }\n\n    .firstarrow3 {\n        position: absolute; \n        left: 37.7%; \n        top: 215px\n    }\n\n    .thirdarrow3 {\n        width: 53px; \n        \n    }\n\n    .secondarrow3 {\n        position: absolute; \n        left: 63.2%; \n        top: 215px\n    }\n\n    .thirdarrow32 {\n        width: 53px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n@media (min-width: 387px) and (max-width: 585px){\n    \n    .firsttopenroll {\n        padding-top: 230px;\n    }\n\n\n    .firstarrow {\n        position: absolute;\n        left: 37.9%; \n        top: 215px;\n    }\n\n    .firstarrow1st{\n        font-size: 12px;\n    }\n\n    .firstarrow2nd {\n        width: 52px; \n        height: 3px; \n        background-color: #156614\n    }\n\n\n    \n    .secondarrow {\n        position: absolute; \n        left: 63.2%;\n        top: 215px;\n    }\n\n    .secondarrow2nd{\n        width: 52px;\n    }\n\n    .secondarrow21st{\n        width: 52px; \n        \n    }\n\n    /* second arrow */\n\n    .firstarrow2 {\n        position: absolute; \n        left: 37.7%; \n        top: 215px;\n    }\n\n    .secondarrow2 {\n        position: absolute; \n        left: 63.2%;\n        top: 215px;\n    }\n\n    .firstarrow21st{\n        width: 53px; \n        height: 3px; \n        background-color: #156614;\n    }\n\n    .firstarrow3 {\n        position: absolute; \n        left: 37.7%; \n        top: 215px\n    }\n\n    .thirdarrow3 {\n        width: 53px; \n        \n    }\n\n    .secondarrow3 {\n        position: absolute; \n        left: 63.2%; \n        top: 215px\n    }\n\n    .thirdarrow32 {\n        width: 53px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n\n@media  (min-width: 597px) and (max-width: 990px) {\n    \n    .firsttopenroll {\n        padding-top: 180px;\n    }\n\n\n    .firstarrow {\n        position: absolute;\n        left: 42.8%; \n        top: 165px;\n    }\n\n    .firstarrow1st{\n        font-size: 12px;\n    }\n\n    .firstarrow2nd {\n        width: 52px; \n        height: 3px; \n        background-color: #156614\n    }\n\n\n    \n    .secondarrow {\n        position: absolute; \n        left: 58.2%;\n        top: 165px;\n    }\n\n    .secondarrow2nd{\n        width: 52px;\n    }\n\n    .secondarrow21st{\n        width: 52px; \n        \n    }\n\n    /* second arrow */\n\n    .firstarrow2 {\n        position: absolute; \n        left: 42.8%; \n        top: 165px;\n    }\n\n    .secondarrow2 {\n        position: absolute; \n        left: 58.2%; \n        top: 165px;\n    }\n\n    .firstarrow21st{\n        width: 53px; \n        height: 3px; \n        background-color: #156614;\n    }\n\n    .firstarrow3 {\n        position: absolute; \n        left: 42.8%; \n        top: 165px;\n    }\n\n    .thirdarrow3 {\n        width: 53px; \n        \n    }\n\n    .secondarrow3 {\n        position: absolute; \n        left: 58.2%; \n        top: 165px;\n    }\n\n    .thirdarrow32 {\n        width: 53px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n@media  (min-width: 998px) and (max-width: 1090px) {\n    \n    .firsttopenroll {\n        padding-top: 220px;\n    }\n\n\n    .firstarrow {\n        position: absolute;\n        left: 42.8%; \n        top: 205px;\n    }\n\n    .firstarrow1st{\n        font-size: 12px;\n    }\n\n    .firstarrow2nd {\n        width: 52px; \n        height: 3px; \n        background-color: #156614\n    }\n\n\n    \n    .secondarrow {\n        position: absolute; \n        left: 58.2%;\n        top: 205px;\n    }\n\n    .secondarrow2nd{\n        width: 52px;\n    }\n\n    .secondarrow21st{\n        width: 52px; \n        \n    }\n\n    /* second arrow */\n\n    .firstarrow2 {\n        position: absolute; \n        left: 42.8%; \n        top: 205px;\n    }\n\n    .secondarrow2 {\n        position: absolute; \n        left: 58.2%; \n        top: 205px;\n    }\n\n    .firstarrow21st{\n        width: 53px; \n        height: 3px; \n        background-color: #156614;\n    }\n\n    .firstarrow3 {\n        position: absolute; \n        left: 42.8%; \n        top: 205px;\n    }\n\n    .thirdarrow3 {\n        width: 53px; \n        \n    }\n\n    .secondarrow3 {\n        position: absolute; \n        left: 58.2%; \n        top: 205px;\n    }\n\n    .thirdarrow32 {\n        width: 53px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n\n@media  (min-width: 1100px) and (max-width: 1290px) {\n    \n    .firsttopenroll {\n        padding-top: 220px;\n    }\n\n\n    .firstarrow {\n        position: absolute;\n        left: 42.8%; \n        top: 205px;\n    }\n\n    .firstarrow1st{\n        font-size: 12px;\n    }\n\n    .firstarrow2nd {\n        width: 52px; \n        height: 3px; \n        background-color: #156614\n    }\n\n\n    \n    .secondarrow {\n        position: absolute; \n        left: 58.2%;\n        top: 205px;\n    }\n\n    .secondarrow2nd{\n        width: 52px;\n    }\n\n    .secondarrow21st{\n        width: 52px; \n        \n    }\n\n    /* second arrow */\n\n    .firstarrow2 {\n        position: absolute; \n        left: 42.8%; \n        top: 205px;\n    }\n\n    .secondarrow2 {\n        position: absolute; \n        left: 58.2%; \n        top: 205px;\n    }\n\n    .firstarrow21st{\n        width: 53px; \n        height: 3px; \n        background-color: #156614;\n    }\n\n    .firstarrow3 {\n        position: absolute; \n        left: 42.8%; \n        top: 205px;\n    }\n\n    .thirdarrow3 {\n        width: 53px; \n        \n    }\n\n    .secondarrow3 {\n        position: absolute; \n        left: 58.2%; \n        top: 205px;\n    }\n\n    .thirdarrow32 {\n        width: 53px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n/* 90% screen */\n@media (min-width: 1400px) and (max-width: 1590px){\n    \n    .firsttopenroll {\n        padding-top: 170px;\n    }\n    \n    \n    \n    .firstarrow {\n        position: absolute;\n        left: 38.4%; \n        top: 148px;\n    }\n    \n    .firstarrow2nd {\n        width: 182px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    /* second arrow */\n    .secondarrow {\n        position: absolute; \n        left: 53.2%;\n        top: 148px\n    }\n    \n    .secondarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    \n    .firstarrow2 {\n        position: absolute; \n        left: 38.3%; \n        top: 148px;\n    }\n    \n    .secondarrow2 {\n        position: absolute; \n        left: 53.2%; \n        top: 148px\n    }\n    \n    .firstarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #156614;\n    }\n    \n    .secondarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    .firstarrow3 {\n        position: absolute; \n        left: 38.3%; \n        top: 148px\n    }\n    \n    .secondarrow3 {\n        position: absolute; \n        left: 53.2%; \n        top: 148px\n    }\n    \n    .thirdarrow3 {\n        width: 184px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    .thirdarrow32 {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n/* 80% screen */\n@media (min-width: 1600px) and (max-width: 1740px){\n    \n    .firsttopenroll {\n        padding-top: 170px;\n    }\n    \n    \n    \n    .firstarrow {\n        position: absolute;\n        left: 39.6%; \n        top: 148px;\n    }\n    \n    .firstarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    /* second arrow */\n    .secondarrow {\n        position: absolute; \n        left: 52.8%;\n        top: 148px\n    }\n    \n    .secondarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    \n    .firstarrow2 {\n        position: absolute; \n        left: 39.6%; \n        top: 148px;\n    }\n    \n    .secondarrow2 {\n        position: absolute; \n        left: 52.8%; \n        top: 148px\n    }\n    \n    .firstarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #156614;\n    }\n    \n    .secondarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    .firstarrow3 {\n        position: absolute; \n        left: 39.6%; \n        top: 148px\n    }\n    \n    .secondarrow3 {\n        position: absolute; \n        left: 52.8%; \n        top: 148px\n    }\n    \n    .thirdarrow3 {\n        width: 184px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    .thirdarrow32 {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n\n\n/* 75% screen */\n@media (min-width: 1790px) and (max-width: 1890px){\n    \n    .firsttopenroll {\n        padding-top: 170px;\n    }\n    \n    \n    \n    .firstarrow {\n        position: absolute;\n        left: 40.3%; \n        top: 148px;\n    }\n    \n    .firstarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    /* second arrow */\n    .secondarrow {\n        position: absolute; \n        left: 52.7%;\n        top: 148px\n    }\n    \n    .secondarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    \n    .firstarrow2 {\n        position: absolute; \n        left: 40.3%; \n        top: 148px;\n    }\n    \n    .secondarrow2 {\n        position: absolute; \n        left: 52.7%; \n        top: 148px\n    }\n    \n    .firstarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #156614;\n    }\n    \n    .secondarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    .firstarrow3 {\n        position: absolute; \n        left: 40.3%; \n        top: 148px\n    }\n    \n    .secondarrow3 {\n        position: absolute; \n        left: 52.6%; \n        top: 148px\n    }\n    \n    .thirdarrow3 {\n        width: 184px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    .thirdarrow32 {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}\n\n\n\n\n/* 67% screen */\n@media (min-width: 1900px) and (max-width: 3000px){\n    \n    .firsttopenroll {\n        padding-top: 170px;\n    }\n    \n    \n    \n    .firstarrow {\n        position: absolute;\n        left: 41.4%; \n        top: 148px;\n    }\n    \n    .firstarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    /* second arrow */\n    .secondarrow {\n        position: absolute; \n        left: 52.3%;\n        top: 148px\n    }\n    \n    .secondarrow2nd {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    \n    .firstarrow2 {\n        position: absolute; \n        left: 41.3%; \n        top: 148px;\n    }\n    \n    .secondarrow2 {\n        position: absolute; \n        left: 52.3%; \n        top: 148px\n    }\n    \n    .firstarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #156614;\n    }\n    \n    .secondarrow21st{\n        width: 184px; \n        height: 3px; \n        background-color: #96c596\n    }\n    \n    .firstarrow3 {\n        position: absolute; \n        left: 41.3%; \n        top: 148px\n    }\n    \n    .secondarrow3 {\n        position: absolute; \n        left: 52.3%; \n        top: 148px\n    }\n    \n    .thirdarrow3 {\n        width: 184px; \n        height: 3px; \n        background-color: #156614\n    }\n    \n    .thirdarrow32 {\n        width: 183px; \n        height: 3px; \n        background-color: #96c596\n    }\n\n    .Enroll-top2 {\n        margin-top: 150px;\n\n        \n    }\n\n    /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n\n    .Enroll-page {\n        background-color: #ffffff; \n        z-index: 100;\n        width: \"100%\";\n    }\n\n    .myfirstcon {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n    .sideshifft {\n        margin: \"50px\"\n    }\n\n\n\n    .textinputs {\n        border-radius: 10px;\n        background-color: #EDECF8; \n        border: 1px solid #EDECF8; \n        height: 40px; \n        width: 240px;\n    \n    }\n\n    input:focus {\n        outline:none !important;\n        outline-width: 0 !important;\n        box-shadow: none;\n        -moz-box-shadow: none;\n        -webkit-box-shadow: none;\n    }\n\n    .formbtn {\n        width: 100px; \n        height: 35px; \n        \n        margin-top: 15px; \n        background-color: #156614; \n        font-size: 13px\n    }\n\n    .firstcontent {\n        margin-top: 70px; \n        margin-bottom: 70px; \n        margin-left: 20px; \n        margin-right: 5px\n    }\n\n    .secondcontent {\n        margin-top: 70px; \n        margin-bottom: 70px;\n        margin-left: 20px; \n        margin-right: 5px;\n    }\n\n\n    .successtabs {\n        margin-top: 150px; \n        margin-bottom: 100px; \n        margin-left: 50px; \n        margin-right: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
